{
  "primer": {
    "eyebrow": "اوقات نماز و قبله",
    "headline": "Rhemn برای اوقات نماز و قبله به موقعیت شما نیاز دارد.",
    "body": "از آن فقط برای اوقات نماز، جهت قبله و آب‌وهوای محلی شما استفاده می‌کنیم — نه چیز دیگری.",
    "cta": "ادامه",
    "skip": "الان نه",
    "skip_body": "اوقات نماز و قبله غیرفعال می‌مانند."
  }
}
